import React, { FC, useEffect } from 'react';
import { getWindow } from '../../../../utils/getWindow';
import { makeTransition, TransitionType } from '../../../../utils/styles/makeTransition';
import { Box } from '../../../layout/Box';
import { usePostDetailsCardContext } from '../PostDetailsCard';
import { PostFooterContainer } from '../styles';
import { PostButton, PostButtonProps } from './PostButton';
import { PostProfile, PostProfileProps } from './PostProfile';

const PRODUCT_BUTTON_ANIMATE_DELAY = 1500;
const ANIMATE_TIME = 250;

type PostFooterProps = PostProfileProps & Omit<PostButtonProps, 'isProductExpanded'>;

export const PostFooter: FC<PostFooterProps> = ({ post, ...props }) => {
    const { isProductExpanded, setIsProductExpanded } = usePostDetailsCardContext();

    useEffect(() => {
        getWindow()?.setTimeout(() => {
            post.products.items.length && setIsProductExpanded(true);
        }, PRODUCT_BUTTON_ANIMATE_DELAY);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [post.products]);

    return (
        <PostFooterContainer>
            <Box
                position="absolute"
                bottom={isProductExpanded ? '68px' : '-2px'}
                left={0}
                maxWidth={isProductExpanded ? '100%' : '55%'}
                transition={makeTransition({
                    ms: ANIMATE_TIME,
                    styles: ['bottom', 'max-width'],
                    type: TransitionType.EASE_OUT,
                })}
            >
                <PostProfile post={post} {...props} />
            </Box>
            <Box
                width={isProductExpanded ? '100%' : '120px'}
                height={isProductExpanded ? '64px' : '32px'}
                transition={makeTransition({
                    ms: ANIMATE_TIME,
                    styles: ['width', 'height'],
                    type: TransitionType.EASE_OUT,
                })}
            >
                <PostButton post={post} isProductExpanded={isProductExpanded} {...props} />
            </Box>
        </PostFooterContainer>
    );
};
